<script>
  import { getContext, setContext, onMount } from "svelte";
  import { writable, derived } from "svelte/store";
  import { LOCATION, ROUTER } from "./contexts.js";
  import { pick, match, combinePaths } from "./utils.js";
  import { location } from "./router.js";

  const locationContext = getContext(LOCATION);
  const routerContext = getContext(ROUTER);

  const routes = writable([]);
  const activeRoute = writable(null);

  const loc = locationContext || location;

  const base = routerContext
    ? routerContext.routerBase
    : writable({
        path: "/",
        uri: "/"
      });

  const routerBase = derived([base, activeRoute], ([base, activeRoute]) => {
    // If there is no activeRoute, the routerBase will be identical to the base.
    if (activeRoute === null) {
      return base;
    }

    const { route, uri } = activeRoute;

    // Remove the potential /* or /*splatname from
    // the end of the child Routes relative paths.
    const path = route.default ? "/" : route.path.replace(/\*.*$/, "");

    return { path, uri };
  });

  function registerRoute(route) {
    let { path } = route;
    route.path = combinePaths("/", path);

    routes.update(rs => {
      rs.push(route);
      return rs;
    });
  }

  function unregisterRoute(route) {
    routes.update(rs => {
      const index = rs.indexOf(route);
      rs.splice(index, 1);
      return rs;
    });
  }

  $: {
    const bestMatch = pick($routes, $loc);
    activeRoute.set(bestMatch);
  }

  if (!locationContext) {
    setContext(LOCATION, location);
  }

  setContext(ROUTER, {
    activeRoute,
    base,
    routerBase,
    registerRoute,
    unregisterRoute
  });
</script>

<slot />
